module.exports = __webpack_public_path__ + "static/media/dashboard-health.270d1b32.svg";